function add(x,y){
    return x+y;
}

module.exports = add;


// WEBPACK FOOTER //
// ./process/add.js